import { endpoints } from './endpoints';
import { getAuthToken } from './http';

export const downloadUrls = {
    cfdiXml(uuid: string): string {
        return endpoints.cfdi.downloadXml(getAuthToken(), uuid);
    },
    cfdiPdf(uuid: string): string {
        return endpoints.cfdi.downloadPdf(getAuthToken(), uuid);
    },
};
